export const openLink = async (url: string): Promise<void> => {
  window.open(url);
};
